import {
  Children,
  FC,
  FunctionComponent,
  ReactElement,
  ReactNode,
  useContext,
} from 'react';
import { OptionContext } from './OptionContext';
import { Option } from './index';

const Selector = ({
  children,
  option,
  defaultOption,
}: {
  children: ReactNode;
  option: Option;
  defaultOption: FC | FC<{ maskID: string }> | FC<{ children: ReactNode }>;
}) => {
  const { options } = useContext(OptionContext);
  const avatarCondition =
    options?.[option.key] || defaultOption.displayName || '';

  const childrenArray = Children.toArray(children) as ReactElement[];
  const matchingChild = childrenArray.find((child) => {
    const componentType = child.type as FunctionComponent;
    return componentType.displayName === avatarCondition;
  });

  return matchingChild ? matchingChild : null;
};

export default Selector;
